import { useContext } from 'react'
import { ActiveInstallationContextProps } from '../types'
import { ActiveInstallationContext } from '../context/active-installation-context'

/**
 * provides context for active installation
 */
const useActiveInstallationContext = (): ActiveInstallationContextProps => {
  const activeInstallationContext = useContext(ActiveInstallationContext)

  if (activeInstallationContext === undefined) {
    throw new Error('active installation context is used outside of its provider')
  }

  return activeInstallationContext
}

export default useActiveInstallationContext
